import React from 'react';

export function StepAuthorizationLabel() {
  return <>Autorizace zaslané žádosti</>;
}
